import {Checkbox} from 'primereact/checkbox'
import {forwardRef, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {isBoolean} from '../observations/Utils'
import {permissionOptionKeys} from '../role/RoleConstant'
import {convertKeyToLabel} from '../table-utils/TableUtils'

const CheckboxUtils = forwardRef(
    ({id, parentKey = '', defaultValue = false, callBack = () => {}}, ref) => {
        useImperativeHandle(ref, () => ({
            value: checked,
            setValue,
        }))
        const {translateCommons, translateKeys} = TranslateUtils()
        const [checked, setChecked] = useState(defaultValue)
        const setValue = value => {
            if (!!isBoolean(value)) {
                setChecked(value)
            }
        }
        return (
            <div className="flex align-items-center">
                <Checkbox
                    inputId={parentKey ? `${parentKey}-${id}` : id}
                    name={id}
                    onChange={e => {
                        setChecked(e.checked)
                        callBack(
                            e?.target?.name === 'inactive'
                                ? {
                                      active: !e?.checked,
                                  }
                                : e?.target?.name === 'deleted'
                                ? {deleted: e?.checked}
                                : {deleted: false, active: true},
                        )
                    }}
                    checked={checked}
                />
                <div className="flex align-items-center mb-0">
                    <label htmlFor={id} className="ml-2 mb-0">
                        {id === permissionOptionKeys.qualified
                            ? translateCommons(
                                  'Qualified for taking care of patients',
                              )
                            : translateKeys(convertKeyToLabel(id))}
                    </label>
                </div>
            </div>
        )
    },
)

export default CheckboxUtils
